export enum ProjectTaskUserRole {
  USER = 'User',
  INDUSTRY_ADMIN = 'IndustryAdmin',
  GROUP_ADMIN = 'GroupAdmin'
}
